export default __webpack_public_path__ + "static/media/Dotspartial Vectors-02.23c13403.png";